import "./sass/style.scss";

require("./js/custom");

require("./js/raining-hearts");

// require('./js/search');
require("./js/mobilescrollcolor");
require("./js/user-favorites");
require("./js/frontpage-headerslider");
